import { PayloadAction, createSlice } from '@reduxjs/toolkit'

type SessionState = {
  redirected: boolean
  isNoPassword: boolean | undefined
  isGuardianNoPassword: boolean | undefined
  hasPasskey: boolean | undefined
  geolocation: string
  isAlertEnabled: boolean
  planGroups: string[] | undefined
  isFamilyGroupLoading: boolean
  registerPasswordEmailSentCount: number
  registerPasswordEmailBlockedDate: string
}

const initialState: SessionState = {
  redirected: false,
  isNoPassword: undefined,
  isGuardianNoPassword: undefined,
  hasPasskey: undefined,
  geolocation: '',
  isAlertEnabled: true,
  planGroups: [],
  isFamilyGroupLoading: false,
  registerPasswordEmailSentCount: 0,
  registerPasswordEmailBlockedDate: ''
}

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    clearSession() {
      return {
        redirected: false,
        isNoPassword: undefined,
        isGuardianNoPassword: undefined,
        hasPasskey: undefined,
        geolocation: '',
        isAlertEnabled: true,
        planGroups: undefined,
        isFamilyGroupLoading: false,
        registerPasswordEmailSentCount: 0,
        registerPasswordEmailBlockedDate: ''
      }
    },
    setRedirected(state, action: PayloadAction<boolean>) {
      state.redirected = action.payload
    },
    setIsNoPassword(state, action: PayloadAction<boolean | undefined>) {
      state.isNoPassword = action.payload
    },
    setIsGuardianNoPassword(state, action: PayloadAction<boolean | undefined>) {
      state.isGuardianNoPassword = action.payload
    },
    setHasPasskey(state, action: PayloadAction<boolean | undefined>) {
      state.hasPasskey = action.payload
    },
    setGeolocation(state, action: PayloadAction<string>) {
      state.geolocation = action.payload
    },
    setIsAlertEnabled(state, action: PayloadAction<boolean>) {
      state.isAlertEnabled = action.payload
    },
    setPlanGroups(state, action: PayloadAction<string[]>) {
      state.planGroups = action.payload
    },
    setIsFamilyGroupLoading(state, action: PayloadAction<boolean>) {
      state.isFamilyGroupLoading = action.payload
    },
    setRegisterPasswordEmailSent(state, action: PayloadAction<{ count: number; blockedDate: string }>) {
      state.registerPasswordEmailSentCount = action.payload.count
      state.registerPasswordEmailBlockedDate = action.payload.blockedDate
    }
  }
})

export const {
  clearSession,
  setRedirected,
  setIsNoPassword,
  setIsGuardianNoPassword,
  setHasPasskey,
  setGeolocation,
  setIsAlertEnabled,
  setPlanGroups,
  setIsFamilyGroupLoading,
  setRegisterPasswordEmailSent
} = sessionSlice.actions

export default sessionSlice
